import axios from '@fs/zion-axios'
import { buildUriQueryList } from '../util/StringUtil'

const BASE_ORDINANCES_PATH = '/service/dmc/ordinances'

// default exports cannot be mocked so this is not used
export default () => {}

export async function deleteOsrs(owsIds, changeMessage) {
  let owsIdsQueryList = ''
  if (owsIds && owsIds.length > 0) {
    owsIdsQueryList = `?${buildUriQueryList('owsId', owsIds)}`
  }
  const config = {
    headers: {
      'X-Reason': changeMessage,
    },
  }
  const response = await axios.delete(`${BASE_ORDINANCES_PATH}/references${owsIdsQueryList}`, config)
  return response
}

export function ctrSearch(earliestPerformedDate, latestPerformedDate, name, officialType, ordinanceType, templeCode) {
  let url = `${BASE_ORDINANCES_PATH}/search?earliestPerformedDate=${earliestPerformedDate}&latestPerformedDate=${latestPerformedDate}&name=${name}&ordinanceType=${ordinanceType}`
  //  let url = `http://localhost:8080/ordinances/search?earliestPerformedDate=${earliestPerformedDate}&latestPerformedDate=${latestPerformedDate}&name=${name}&ordinanceType=${ordinanceType}`;

  url += officialType ? `&officialType=${officialType}` : ''
  url += templeCode ? `&templeCode=${templeCode}` : ''

  const config = null
  // const config = {
  //   headers: {
  //     'Authorization': `Bearer fb54b047-bba1-4160-83ac-27d8775cbbf3-beta`,
  //   },
  // }

  return axios.get(url, config).then((response) => {
    return response.data
  })
}

export async function getUserCompletedOrdinances(userId, idType, offset, limit, groupByPrincipalPersonId) {
  const response = await axios.get(
    `${BASE_ORDINANCES_PATH}/users/${userId}?idType=${idType}&offset=${offset}&limit=${limit}&groupByPrincipalPersonId=${groupByPrincipalPersonId}`
  )
  return response
}

export async function getUserCompletedOrdinancesCount(userId, idType, groupByPrincipalPersonId) {
  const groupByQuery = groupByPrincipalPersonId ? `&groupByPrincipalPersonId=${groupByPrincipalPersonId}` : ''
  const response = await axios.get(`${BASE_ORDINANCES_PATH}/users/${userId}/count?idType=${idType}${groupByQuery}`)
  return response
}

export async function updateUserOrdinancesHiddenFlag(userId, idType, ctrId, hiddenFromUser) {
  // Need to create the body for this request
  const updateFlagBody = {
    userId,
    idType,
    rtoId: ctrId,
    hiddenFromUser: hiddenFromUser !== 'true',
  }
  const response = await axios.post(`${BASE_ORDINANCES_PATH}/users/update/${ctrId}`, updateFlagBody)
  return response
}

export function createEntityRef(createEntityRefRequest) {
  return axios.post(`${BASE_ORDINANCES_PATH}/entityref`, createEntityRefRequest)
}

export function createMultipleEntityRefs(createEntityRefRequests) {
  return axios.post(`${BASE_ORDINANCES_PATH}/entityrefs`, createEntityRefRequests)
}

export async function getOrdinanceStatusForPerson(personId) {
  const response = await axios.get(`${BASE_ORDINANCES_PATH}/person/${personId}/statuses`)
  return response
}

export async function getOrdinancesFromOrdinanceStatus(personId) {
  const response = await axios.get(`${BASE_ORDINANCES_PATH}/person/${personId}/status-ordinances`)
  return response
}
